import { render, staticRenderFns } from "./TmPageHeader.vue?vue&type=template&id=039cdfbc&scoped=true&"
import script from "./TmPageHeader.vue?vue&type=script&lang=js&"
export * from "./TmPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./TmPageHeader.vue?vue&type=style&index=0&id=039cdfbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cdfbc",
  null
  
)

export default component.exports